var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNewTab = function SvgNewTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.833 13.833H2.167V2.167H8V.5H2.167C1.242.5.5 1.25.5 2.167v11.666c0 .917.742 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V8h-1.667v5.833ZM9.667.5v1.667h2.991l-8.191 8.191 1.175 1.175 8.191-8.191v2.991H15.5V.5H9.667Z",
    fill: "currentColor"
  })));
};

export { SvgNewTab as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjgzMzMgMTMuODMzM0gyLjE2NjY3VjIuMTY2NjdIOFYwLjVIMi4xNjY2N0MxLjI0MTY3IDAuNSAwLjUgMS4yNSAwLjUgMi4xNjY2N1YxMy44MzMzQzAuNSAxNC43NSAxLjI0MTY3IDE1LjUgMi4xNjY2NyAxNS41SDEzLjgzMzNDMTQuNzUgMTUuNSAxNS41IDE0Ljc1IDE1LjUgMTMuODMzM1Y4SDEzLjgzMzNWMTMuODMzM1pNOS42NjY2NyAwLjVWMi4xNjY2N0gxMi42NTgzTDQuNDY2NjcgMTAuMzU4M0w1LjY0MTY3IDExLjUzMzNMMTMuODMzMyAzLjM0MTY3VjYuMzMzMzNIMTUuNVYwLjVIOS42NjY2N1oiIGZpbGw9IiNGNEY0RjQiLz4KPC9zdmc+Cg==";